import React, { useContext } from 'react';
import DocumentTitle from 'react-document-title';
import { getFormattedPageTitle } from 'util/Misc';
import { VisuallyHiddenAnnouncementTrigger } from 'VisuallyHiddenAnnouncement';
import ListingHelpButton from '../list/ListingHelpButton';
import EditContext from './EditContext';
import EditStatusDisplay from './EditStatusDisplay';
import OnFieldValueChange from './fields/OnFieldValueChange';

/**
 * Component that contains the title of the entity in the edit page. Also displays a single field as a subtitle
 * which is useful for users when there are many tabs on the page to remember what they're editing/creating.
 */
function EditTitle() {
	const editContext = useContext(EditContext);

	let pageAlert: string | null = null;

	const { singularName, userFriendlyNameField, hideViewOnly } = editContext.entityDefinition;
	const title = (editContext.isCreateMode ? 'Create' : hideViewOnly ? 'Edit' : 'View') + ' ' + singularName;
	const valueKey = userFriendlyNameField ? userFriendlyNameField : 'name';

	if (pageAlert === null) {
		pageAlert = `Navigated to ${title}`;

		if (!editContext.isCreateMode && editContext.values) {
			pageAlert += ' ' + editContext.values[valueKey];
		}
	}

	return (
		<DocumentTitle title={getFormattedPageTitle(title)}>
			<h1 className="edit-form__title">
				<div className="edit-form__title-item">
					{title}

					<span className="edit-form__title-display">
						<OnFieldValueChange field={valueKey}>
							{({ value }) => {
								return value ? ': ' + value : null;
							}}
						</OnFieldValueChange>
					</span>

					<VisuallyHiddenAnnouncementTrigger message={pageAlert || ''} />
				</div>

				{!editContext.isCreateMode && !editContext.entityDefinition.hideStatusOnEdit && editContext.values ? (
					<div className="edit-form__title-item">
						<EditStatusDisplay record={editContext.values} popoverPlacement="bottom" />
					</div>
				) : null}

				<div className="edit-form__title-item">
					<ListingHelpButton
						entityDefinition={editContext.entityDefinition}
						iconClassNames="listing-item-status-icon"
						linkClassNames="listing-status-btn"
					/>
				</div>
			</h1>
		</DocumentTitle>
	);
}

export default EditTitle;
